export default "__VITE_ASSET__CrN_3sIY__"